import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS3 = props => {
    const ans = '特殊才能'
    const select_arr = [
        {
            value: '1',
            label: '球類'
        },
        {
            value: '2',
            label: '田徑'
        },
        {
            value: '3',
            label: '游泳'
        },
        {
            value: '4',
            label: '武術'
        },
        {
            value: '5',
            label: '美術'
        },
        {
            value: '6',
            label: '樂器演奏'
        },
        {
            value: '7',
            label: '歌唱'
        },
        {
            value: '8',
            label: '工藝'
        },
        {
            value: '9',
            label: '家事'
        },
        {
            value: '10',
            label: '演說'
        },
        {
            value: '11',
            label: '寫作'
        },
        {
            value: '12',
            label: '舞蹈'
        },
        {
            value: '13',
            label: '戲劇'
        },
        {
            value: '14',
            label: '書法'
        },
        {
            value: '15',
            label: '珠算'
        },
        {
            value: '16',
            label: '領導'
        },
        {
            value: '17',
            label: '英打'
        },
        {
            value: '18',
            label: '中打'
        },
        {
            value: '19',
            label: '外語'
        },
        {
            value: '20',
            label: '電腦'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s3"
                   type="checkbox"/>
        </div>
    )
}

export default SseS3


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS3.jsx